import { ICounterpartySearchResult } from '../types/interfaces';
import { ISetCounterpartySearchResult, ISetCounterpartySearchValue } from '../types/actions';
import { ActionTypes } from '../types/actionTypes';

// eslint-disable-next-line import/prefer-default-export
export const SetCounterpartySearchResult = (payload: ICounterpartySearchResult): ISetCounterpartySearchResult => ({
  type: ActionTypes.SET_COUNTERPARTY_SEARCH_RESULT,
  payload,
});
export const setCounterpartySearchValue = (payload: string): ISetCounterpartySearchValue => ({
  type: ActionTypes.SET_COUNTERPARTY_SEARCH_VALUE,
  payload,
});

export const setCounterpartyErrors = (payload: string) => ({
  type: ActionTypes.SET_COUNTERPARTY_ERRORS,
  payload,
});
